import Linkbar from "@coworker/apprestructured/src/shared/components/Linkbar/Linkbar";
import { useAllTaskTypes } from "../../../services/useTaskTypes";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import styles from "./TaskTypesListPage.module.css";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { useTranslation } from "@coworker/locales";

export default function TaskTypesListPage() {
  const { data: taskTypes } = useAllTaskTypes();
  const fixaNavigate = useFixaNavigate();
  const { t } = useTranslation();

  return (
    <>
      <Linkbar currentLabel="Task types" currentAsH1 />

      <div className={styles["task-types-list-page"]}>
        <FixaListView id="task-types-list">
          {taskTypes
            ? taskTypes.map((item) => (
                <FixaListViewItem
                  key={item.id}
                  title={<b>{item.id}</b>}
                  control="navigational"
                  description={t(item.label)}
                  href={`/task-types/${item.id}`}
                  onClick={() => {
                    fixaNavigate(`/task-types/${item.id}`);
                  }}
                />
              ))
            : null}
        </FixaListView>
      </div>
      <FixaButton
        text="Create task type"
        onClick={() => {
          fixaNavigate("/task-types/create");
        }}
      />
    </>
  );
}
